module.exports = __webpack_public_path__ + "static/media/facebook.3af98b07.png";